import {useBookedAppointmentConfirmation} from 'presentation/modules/booking/shared/hooks/useBookedAppointmentConfirmation';
import {useParams} from 'react-router-dom';

export function useMyAppointmentsDetails() {
	const {id} = useParams();
	const {confirmedBookAppointment, appointmentsListLoading, appointmentsListError} =
		useBookedAppointmentConfirmation(id);

	const shouldRedirect = !id || !confirmedBookAppointment;

	return {
		confirmedBookAppointment,
		appointmentsListLoading,
		appointmentsListError,
		shouldRedirect,
	};
}
